(() => {
  if (window.bebiciaInstagramStack) return;
  window.bebiciaInstagramStack = true;
  const instances = new Map();
  const init = root => {
    root.querySelectorAll('[data-instagram-stack]').forEach(section => {
      if (instances.has(section)) return;
      const track = section.querySelector('[data-instagram-picks-track]');
      const cards = [...track.querySelectorAll('.bebicia-instagram-picks__card')];
      if (!cards.length) return;
      const abort = new AbortController();
      const on = (node, type, fn) => node.addEventListener(type, fn, {signal: abort.signal});
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const pause = section.querySelector('[data-instagram-picks-pause]');
      let active = 0, paused = motion.matches, visible = false, hovering = false, focused = false;
      let start = null, dragged = false, lastMove = 0;
      let resumeAfter = 0;
      const render = () => {
        const width = Math.min(420, track.clientWidth / 2.7);
        track.style.setProperty('--stack-card-width', `${width}px`);
        const offset = width * .48;
        cards.forEach((card, i) => {
          let delta = (i - active + cards.length) % cards.length;
          if (delta > cards.length / 2) delta -= cards.length;
          const position = Math.max(-3, Math.min(3, delta));
          card.dataset.stackPosition = String(position);
          card.style.setProperty('--stack-x', `${position * offset}px`);
          card.style.setProperty('--stack-scale', position === 0 ? '1' : Math.abs(position) === 1 ? '.82' : '.68');
          card.style.setProperty('--stack-angle', '0deg');
          card.style.zIndex = String(10 - Math.abs(position));
          card.tabIndex = position === 0 ? 0 : -1;
          card.setAttribute('aria-hidden', String(Math.abs(position) > 2));
        });
        pause.setAttribute('aria-pressed', String(paused));
        pause.setAttribute('aria-label', paused ? '自動再生を開始' : '自動再生を一時停止');
        pause.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
      };
      const move = direction => {
        if (performance.now() - lastMove < 680) return;
        active = (active + direction + cards.length) % cards.length;
        lastMove = performance.now();
        render();
      };
      on(section.querySelector('[data-instagram-picks-prev]'), 'click', () => move(-1));
      on(section.querySelector('[data-instagram-picks-next]'), 'click', () => move(1));
      on(pause, 'click', () => { paused = !paused; render(); });
      on(section, 'pointerenter', e => { if (e.pointerType === 'mouse') hovering = true; });
      on(section, 'pointerleave', () => { hovering = false; resumeAfter = performance.now() + 2800; });
      on(section, 'focusin', () => { focused = true; });
      on(section, 'focusout', e => { focused = section.contains(e.relatedTarget); });
      on(track, 'dragstart', e => e.preventDefault());
      on(track, 'pointerdown', e => {
        start = {x:e.clientX,y:e.clientY}; dragged = false;
        paused = true;
        render();
      });
      on(window, 'pointerup', e => {
        if (!start) return;
        const dx = e.clientX - start.x, dy = e.clientY - start.y;
        start = null;
        if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) { dragged = true; move(dx < 0 ? 1 : -1); }
      });
      on(window, 'pointercancel', () => { start = null; });
      on(track, 'click', e => {
        const card = e.target.closest('.bebicia-instagram-picks__card');
        if (!card) return;
        if (dragged) { e.preventDefault(); dragged = false; return; }
        const position = Number(card.dataset.stackPosition);
        if (position !== 0) e.preventDefault();
      });
      on(track, 'keydown', e => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault(); move(e.key === 'ArrowLeft' ? -1 : 1); cards[active].focus({preventScroll:true});
        }
      });
      on(motion, 'change', () => { paused = motion.matches; render(); });
      on(section, 'shopify:block:select', e => {
        const index = cards.findIndex(card => card === e.target || card.contains(e.target));
        if (index >= 0) { paused = true; render(); }
      });
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; });
      observer.observe(section);
      const resize = new ResizeObserver(render);
      resize.observe(track);
      const timer = setInterval(() => {
        if (visible && !paused && !hovering && !focused && !document.hidden && !start && performance.now() >= resumeAfter) move(1);
      }, 2800);
      section.classList.add('is-stack-ready');
      render();
      instances.set(section, () => { abort.abort(); observer.disconnect(); resize.disconnect(); clearInterval(timer); });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('shopify:section:unload', e => {
    for (const [section, dispose] of instances) if (e.target.contains(section)) { dispose(); instances.delete(section); }
  });
})();
